import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { NbMenuService, NbSidebarService } from '../../../@nebular/theme';
import { NbAuthService, NbAuthSimpleToken } from '../../../@nebular/auth';
import { AnalyticsService } from '../../../@core/utils/analytics.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  @Input()
  position = 'normal';

  user: any;

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private authService: NbAuthService,
    private analyticsService: AnalyticsService,
    private router: Router,
  ) {
    this.authService.onTokenChange().subscribe((token: NbAuthSimpleToken) => {
      this.user = token;
    });
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  onMenuClick(menu) {
    if (menu.title === 'Log out') {
      localStorage.removeItem('auth_app_token');
      this.router.navigate(['/auth/login']);
    }
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@theme/components/header/header.component.ts